// removed by extract-text-webpack-plugin
module.exports = {"container":"_3kTm7172_lg-kBJhHL6Ib-"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Templates/MassiveCreate/SendMassiveContract/styles.css
// module id = 2979
// module chunks = 0